<template>
  <div class="clubs">
    <el-form :model="clubData" :rules="validators" ref="clubData" label-width="200px" class="edit-club-form">

      <div v-if="userIsSuperAdmin">
        <el-form-item label="Client" prop="client_id">
          <el-select v-model="clubData.client_id" placeholder="Client">
            <div v-for="client in clients" :key="client.id">
              <el-option :label="client.name" :value="String(client.id)"></el-option>
            </div>
          </el-select>
        </el-form-item>
      </div>

      <el-form-item label="Name" prop="name">
        <el-input v-model="clubData.name"></el-input>
      </el-form-item>

      <el-form-item label="Primary Contact Name" prop="primary_contact_name">
        <el-input v-model="clubData.primary_contact_name"></el-input>
      </el-form-item>

      <el-form-item label="Primary Contact Number" prop="primary_contact_number">
        <el-input v-model="clubData.primary_contact_number"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="save" @click="submit('clubData')">Save</el-button>
        <el-button type="cancel" @click="close">Cancel</el-button>
      </el-form-item>

    </el-form>
  </div>

</template>

<script>
import auth from '../../auth';
import requests from '../../requests';

export default {
  name: 'admin-clubs-form',
  props: { clubData: Object, isNewClub: Boolean },
  data () {
    return {
      pageName: 'Club Form',
      userIsSuperAdmin: false,
      clients: [],
      validators: {
        name: [
          { required: true, message: "Please input the club's name.", trigger: 'blur'},
          { min:2, max: 254, message: "Must be between 2-254 characters.", trigger: 'blur' },
        ],
        client_id: [
          { required: true, message: "Please select a client.", trigger: 'blur' },
        ]
      }
    }
  },
  beforeMount() {
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = (profile.role === 3);

    if (this.userIsSuperAdmin) {
      requests.getAllClients(this, result => {
        if(result.action === 'success'){
          this.clients = result.data;
          console.log(JSON.stringify(this.clients))
        } else {
          this.$message({
            type: 'error',
            message: 'Failed to recieve clients'
          });
        }
      });
    } else {
      this.setClientId();
    }
  },
  methods: {
    newClub () {
      console.log(JSON.stringify(this.clubData))
      requests.newClub(this, this.clubData, result => {
        if (result.action !== 'success') {
          this.$message({
            type: 'error',
            message: 'Failed to create club: ' + result.msg,
            showClose: true
          })
        } else {
          this.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully created club ' + this.clubData.name
          });
          this.close()
        }
      })
    },
    editClub () {
      requests.updateClub(this, this.clubData.id, this.clubData, result => {
        if (result.action !== 'success') {
          this.$message({
            type: 'error',
            message: 'Failed to update club: ' + result.msg,
            showClose: true
          })
        } else {
          this.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully updated club ' + this.clubData.name
          });
          this.close()
        }
      })
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isNewClub ? this.newClub() : this.editClub()
        } else {
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    setClientId() {
      var profile = JSON.parse(auth.getProfile());
      this.clubData.client_id = String(profile.client_id);
    },
    close() {
      this.reset('clubData')
      this.$emit('close');
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClubForm.vue?23593f17